import React from "react";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {
	RouterProvider,
	createBrowserRouter,
	useNavigate,
} from "react-router-dom";
import {store, persistor} from "../store/store";
import protected_routes from "./ProctectedRoutes";
import {BrandProvider} from "../component/BrandProvider";
import {Security} from "@okta/okta-react";
import {
	OktaAuth,
	toRelativeUrl,
	OktaAuthOptions,
	TokenManagerInterface,
	AccessToken,
	IDToken,
	UserClaims,
	TokenParams,
} from "@okta/okta-auth-js";
import config from "../config";
import {OktaContext} from "../store/okta";

const Routing = () => {
	const history = useNavigate();

	const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
		history(toRelativeUrl(originalUri, window.location.origin));
	};

	const onAuthRequired = function () {
		history("/login");
	};

	const oktaAuth = new OktaAuth(config.oidc);

	const oktaReducer = (oktaClient: any, action: any) => {
		return oktaClient;
	};

	const [oktaClient, dispatch] = React.useReducer(oktaReducer, oktaAuth);

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<Security
					oktaAuth={oktaAuth}
					restoreOriginalUri={restoreOriginalUri}
					onAuthRequired={onAuthRequired}
				>
					<BrandProvider>
						<OktaContext.Provider value={oktaClient}>
							{protected_routes}
						</OktaContext.Provider>
					</BrandProvider>
				</Security>
			</PersistGate>
		</Provider>
	);
};
export default Routing;
